export const getAdminMenuItems = () => [
  {
    group: 'Business',
    label: 'sidebar.CustomersDashboard',
    to: '/customers',
    icon: 'groups',
  },
  {
    group: 'Business',
    label: 'sidebar.ContractsDashboard',
    to: '/contracts',
    icon: 'description',
  },
  {
    group: 'Business',
    label: 'sidebar.InvoicingDashboard',
    to: '/invoicing',
    icon: 'receipt_long',
  },
  {
    group: 'Business',
    label: 'sidebar.Vendors',
    to: '/vendors',
    icon: 'storefront',
  },
  {
    group: 'Business',
    label: 'sidebar.PaymentProviders',
    to: '/payment-providers',
    icon: 'payment',
  },
  {
    group: 'Business',
    label: 'sidebar.Contacts',
    to: '/contacts',
    icon: 'contacts',
  },
  {
    group: 'Traffic',
    label: 'sidebar.UsageRecompilation',
    to: '/usage-recompilation',
    icon: 'autorenew',
  },
  {
    group: 'Traffic',
    label: 'sidebar.SessionsTraffic',
    to: '/sessions-traffic',
    icon: 'traffic',
  },
  {
    group: 'Traffic',
    label: 'sidebar.UsageTraffic',
    to: '/usage-traffic',
    icon: 'data_usage',
  },
  {
    group: 'Traffic',
    label: 'sidebar.UsageUnits',
    to: '/usage-units',
    icon: 'straighten',
  },
  {
    group: 'Traffic',
    label: 'sidebar.Costs',
    to: '/costs',
    icon: 'attach_money',
  },
  {
    group: 'Traffic',
    label: 'sidebar.AwsResources',
    to: '/aws-resources',
    icon: 'cloud',
  },
  {
    group: 'Traffic',
    label: 'sidebar.ThresholdManagement',
    to: '/threshold-management',
    icon: 'data_thresholding',
  },
  {
    group: 'Traffic',
    label: 'sidebar.Reconciliation',
    to: '/reconciliation',
    icon: 'balance',
  },
  {
    group: 'SKU',
    label: 'sidebar.SkuManagement',
    to: '/sku-management',
    icon: 'package_2',
  },
  {
    group: 'SKU',
    label: 'sidebar.MappingDashboard',
    to: '/sku-mapping',
    icon: 'scatter_plot',
  },
  {
    group: 'SKU',
    label: 'sidebar.ErroredSkusDashboard',
    to: '/errored-skus',
    icon: 'error_outline',
  },
  {
    group: 'Business',
    label: 'sidebar.ProgressiveTiers',
    to: '/progressive-tiers',
    icon: 'stairs',
  },
  {
    group: 'Business',
    label: 'sidebar.TiersDashboard',
    to: '/tiers',
    icon: 'card_giftcard',
  },
  {
    group: 'OPS',
    label: 'sidebar.Databases',
    to: '/reporting-databases',
    icon: 'database',
  },
  {
    group: 'OPS',
    label: 'sidebar.AccountsDashboard',
    to: '/accounts',
    icon: 'manage_accounts',
  },
  {
    group: 'OPS',
    label: 'sidebar.Flows',
    to: '/flows',
    icon: 'account_tree',
  },
  {
    group: 'OPS',
    label: 'sidebar.Audit',
    to: '/audit',
    icon: 'history',
  },
  {
    group: 'OPS',
    label: 'sidebar.LoginAudit',
    to: '/login-audit',
    icon: 'passkey',
  },
  {
    group: 'OPS',
    label: 'sidebar.EnvironmentsDashboard',
    to: '/environments',
    icon: 'domain',
  },
  {
    group: 'OPS',
    label: 'sidebar.Services',
    to: '/services',
    icon: 'list',
  },
  {
    group: 'Business',
    label: 'sidebar.SageJournalStatus',
    to: '/admin/sage-accrual',
    icon: 'request_quote',
  },
  {
    group: 'OPS',
    label: 'sidebar.Users',
    to: '/users',
    icon: 'groups',
  },
];
